import { CanMatchFn, UrlSegment } from '@angular/router';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isShareToken(value: string): boolean {
  return UUID_PATTERN.test(value);
}

/** A malformed token never reaches the API; it falls through to the not-found route. */
export const shareTokenGuard: CanMatchFn = (_route, segments: UrlSegment[]) =>
  isShareToken(segments[0]?.path ?? '');
